module.exports = __webpack_public_path__ + "static/img/left-bottom-row-6.e4b7dd26.webp";